import { useCallback } from 'react';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { useNavigate } from '@tanstack/react-router';

import { useBoardTheme } from '@exports/hooks/useBoardTheme';

import { IPoolType } from '@features/game/types/fast-game';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

import { CreateFriendGameModalWidget } from './components/CreateFriendGameModal';
import { FriendLobbyPage } from './FriendLobbyPage';

export function FriendLobbyPageWidget({ initialPool }: { initialPool: IPoolType | undefined }) {
  const { boardTheme } = useBoardTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery() !== 'desktop';

  const onClose = useCallback(() => {
    navigate({ to: '/' });
  }, [navigate]);

  return (
    <FriendLobbyPage
      avatar={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget alwaysRound />
        </>
      }
      modal={(className) => (
        <CreateFriendGameModalWidget
          className={className}
          closeText="Вернуться на главную"
          initialPool={initialPool}
          onClose={isMobile ? onClose : undefined}
        />
      )}
      boardTheme={boardTheme}
    />
  );
}
